import React from 'react'
import { Container } from 'react-bootstrap'
import './../assest/style/Services.css'

import 'bootstrap/dist/css/bootstrap.min.css';
import Slider from 'react-slick';
import market from './../assest/images/Services/market.png'
import ph from './../assest/images/Services/ph.png'
import id from './../assest/images/Services/id.png'
import Ai from './../assest/images/Services/Ai.png'
import pr from './../assest/images/Services/pr.png'
import content from './../assest/images/Services/content.png'
export const Services = () => {
    const services=[
        {
            images:market,
            title:"Marketing",
            description:"Creative and effective digital marketing services. Through customized marketing strategies that enhance your brand's visibility and achieve tangible results. "
        },
        {
            images:ph,
            title:"Adobe Photoshop",
            description:"Crafting brilliance from your ideas – advanced Photoshop design services to turn your vision into an artistic reality that exceeds expectations"
        },
        {
            images:market,
            title:"Logo",
            description:"Innovating identity with a unique touch. We're here to design a logo that reflects your essence and highlights your uniqueness with creative dimensions"
        },
        {
            images:Ai,
            title:"Visual identity",
            description:"Crafting the vision with colors of creativity and design. Visual identity services that embody your message and distinguish you with a unique style."
        },
        {
            images:id,
            title:"Adobe InDesign",
            description:"Unleash boundless creativity with Adobe InDesign! Advanced design services to create stunning prints and professional documents that reflect the best of your work"
        },
        {
            images:pr,
            title:"Adobe Premiere",
            description:"Unleash creativity and cinematic flair with Adobe Premiere! Advanced video editing services to transform your ideas into impactful and engaging stories"
        },
        {
            images:content,
            title:"Content Writting",
            description:"Content writing services in both Arabic and English, embodying creativity and professionalism to effectively convey your message to your audience"
        },
    ]
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 3,
        initialSlide: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 2,
              initialSlide: 2,
              infinite: true,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
            }
          }
        ]
      };
      
  return (
    <div className='services'>
<Container>
    <div className='row'>
        <div className='col-lg-4 col-md-4 col-sm-12'>
            <h5>My Services</h5>
            <h4>We'll be together</h4>
        </div>
        <div className='col-lg-8 col-md-8 col-sm-12'>
        <Slider {...settings}>
    {services.map((value,index)=>{
        return(
            <div className='card' key={index}>
              
                <div className='img'>
                <img src={value.images}/>
                </div>
                <h3>{value.title}</h3>
                <h6>{value.description}</h6>
                <button className='btnn'>View More</button>
            </div>
        )
    }) }
    </Slider>
        </div>
    </div>
</Container>
    </div>
  )
}
